import React, { useState } from "react";
import "./ScheduledReports.css";
import Calendar from "../../../components/Calendar/Calendar";

// Built-in data — ignores the prop and uses this instead
const SCHEDULED_DATA = [
  {
    id: 1,
    date: new Date(2026, 4, 7), // May 7
    time: "09:00 AM",
    duration: "30 min",
    type: "report",
    title: "Weekly Sales Report",
    description: "Auto-generated sales summary for last week",
    iconBg: "#d1fae5",
    iconColor: "#059669",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
    ),
  },
  {
    id: 2,
    date: new Date(2026, 4, 7), // May 7
    time: "11:00 AM",
    duration: "60 min",
    type: "meeting",
    title: "Q2 Planning Meeting",
    description: "Strategy alignment with department leads",
    iconBg: "#fef3c7",
    iconColor: "#d97706",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    id: 3,
    date: new Date(2026, 4, 7), // May 7
    time: "02:30 PM",
    duration: "45 min",
    type: "presentation",
    title: "Client Presentation",
    description: "Revenue dashboard walkthrough for Acme Corp",
    iconBg: "#dbeafe",
    iconColor: "#2563eb",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
        <line x1="8" y1="21" x2="16" y2="21" />
        <line x1="12" y1="17" x2="12" y2="21" />
      </svg>
    ),
  },
  {
    id: 4,
    date: new Date(2026, 4, 7), // May 7
    time: "04:00 PM",
    duration: "20 min",
    type: "report",
    title: "Daily KPI Summary",
    description: "End-of-day key performance indicators",
    iconBg: "#fce7f3",
    iconColor: "#db2777",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="18" y1="20" x2="18" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="6" y1="20" x2="6" y2="14" />
      </svg>
    ),
  },
  {
    id: 5,
    date: new Date(2026, 4, 11), // May 11
    time: "10:00 AM",
    duration: "30 min",
    type: "report",
    title: "Monthly Revenue Report",
    description: "Full revenue breakdown for April 2026",
    iconBg: "#d1fae5",
    iconColor: "#059669",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="12" y1="1" x2="12" y2="23" />
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
    ),
  },
  {
    id: 6,
    date: new Date(2026, 4, 11), // May 11
    time: "02:00 PM",
    duration: "45 min",
    type: "meeting",
    title: "Sprint Retrospective",
    description: "Team review of last sprint performance",
    iconBg: "#e0e7ff",
    iconColor: "#6366f1",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    id: 7,
    date: new Date(2026, 4, 14), // May 14
    time: "09:30 AM",
    duration: "60 min",
    type: "presentation",
    title: "Board Presentation",
    description: "Q1 results and Q2 forecast for board members",
    iconBg: "#fef3c7",
    iconColor: "#d97706",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
        <line x1="8" y1="21" x2="16" y2="21" />
        <line x1="12" y1="17" x2="12" y2="21" />
      </svg>
    ),
  },
  {
    id: 8,
    date: new Date(2026, 4, 21), // May 21
    time: "11:00 AM",
    duration: "30 min",
    type: "report",
    title: "Inventory Status Report",
    description: "Weekly stock levels and reorder alerts",
    iconBg: "#d1fae5",
    iconColor: "#059669",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
      </svg>
    ),
  },
  {
    id: 9,
    date: new Date(2026, 4, 28), // May 28
    time: "03:00 PM",
    duration: "45 min",
    type: "meeting",
    title: "End of Month Review",
    description: "Final metrics review before month close",
    iconBg: "#fce7f3",
    iconColor: "#db2777",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
  },
];

const ScheduledReportsOverview = () => {
  const today = new Date();
  const [selectedDate, setSelectedDate] = useState(today);

  const getReportsForDate = (date) => {
    if (!date) return [];
    return SCHEDULED_DATA.filter((r) => r.date.toDateString() === date.toDateString());
  };

  const formatSelectedDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
    });
  };

  const filteredReports = getReportsForDate(selectedDate);
  const reportDates = SCHEDULED_DATA.map((r) => r.date);

  return (
    <div className="scheduled-reports-container">
      <div className="scheduled-reports-left-section">
        <Calendar selectedDate={selectedDate} onDateSelect={setSelectedDate} reportDates={reportDates} />
      </div>

      <div className="scheduled-reports-right-section">
        <div className="scheduled-reports-header">
          <h3 className="scheduled-reports-title">Scheduled Reports</h3>
          <p className="scheduled-reports-subtitle">
            {selectedDate
              ? `${formatSelectedDate(selectedDate)} · ${filteredReports.length} ${filteredReports.length === 1 ? "item" : "items"}`
              : "No date selected"}
          </p>
        </div>

        <div className="scheduled-reports-list">
          {filteredReports.length > 0 ? (
            filteredReports.map((report) => (
              <div key={report.id} className="scheduled-report-card">
                <div
                  className="scheduled-report-icon"
                  style={{ backgroundColor: report.iconBg, color: report.iconColor }}
                >
                  {report.icon}
                </div>
                <div className="scheduled-report-details">
                  <h5 className="scheduled-report-title">{report.title}</h5>
                  <p className="scheduled-report-description">{report.description}</p>
                  <div className="scheduled-report-meta">
                    <span className="scheduled-report-time">
                      <svg width="13" height="13" viewBox="0 0 14 14" fill="none">
                        <circle cx="7" cy="7" r="6" stroke="currentColor" strokeWidth="1.5" />
                        <path d="M7 3.5V7L9.5 9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                      </svg>
                      {report.time}
                    </span>
                    <span className="scheduled-report-divider">·</span>
                    <span className="scheduled-report-duration">{report.duration}</span>
                    <span className="scheduled-report-divider">·</span>
                    <span className="scheduled-report-type">{report.type}</span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="scheduled-reports-no-reports">
              <p>No reports scheduled for this date</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ScheduledReportsOverview;
